// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__-qd96","ScrollX":"Scroll_ScrollX__1Y19C","ScrollY":"Scroll_ScrollY__Qulok"};